var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", [
        _vm._v("\n        Beschädigte Bereiche bitte kennzeichnen\n    "),
      ]),
      _vm._v(" "),
      _c("csp-record-damage-image-select", {
        attrs: { "damage-form": _vm.damageForm },
        on: { change: _vm.setDamageImage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }